import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { NotificationState, StoreFacade } from '@smata-notification';
import { EMPTY, Observable, tap } from 'rxjs';

import { customCatchErrorNonNgrx } from '../util/utility';
import { Actions } from './notification-page.actions';

@Injectable({
  providedIn: 'root',
})
export class NotificationFacade implements StoreFacade<Actions> {
  private readonly store = inject(Store<NotificationState>);

  observeApiCall<T>(api: () => Observable<T>, onSuccess?: () => void, onError?: () => void) {
    let success = true;

    return api().pipe(
      customCatchErrorNonNgrx(this, () => {
        success = false;
        return EMPTY;
      }),
      tap(() => {
        if (success && onSuccess) {
          onSuccess();
        } else if (!success && onError) {
          onError();
        }
      }),
    );
  }

  dispatch(action: Actions) {
    this.store.dispatch(action);
  }
}
